export default __webpack_public_path__ + "static/media/unlink-content.b76f73a3.svg";